export default __webpack_public_path__ + "static/media/jail.a892fae0.png";